export class UserPermissions {
    isDownloadAllowed: boolean;
    isDirectLinkAllowed: boolean;
    isZipAllowed: boolean;
    isUnzipAllowed: boolean;
    isCopyAllowed: boolean;
    isCutAllowed: boolean;
    isRenameAllowed: boolean;
    isDeleteAllowed: boolean;
    isRestoreAllowed = true;
    isCopyInBufferAllowed = true;
    constructor(private permisions) {
        this.isDownloadAllowed = this.permisions.web_download;
        this.isDirectLinkAllowed = this.permisions.web_download
        this.isZipAllowed = this.permisions.web_manage;
        this.isUnzipAllowed = this.permisions.web_manage;
        this.isCopyAllowed = this.permisions.web_manage;
        this.isCutAllowed = this.permisions.web_manage;
        this.isDeleteAllowed = this.permisions.web_delete;
        this.isRenameAllowed = this.permisions.web_manage
    }
}
